<template>
    <div class="bg-white border-primary border rounded-2xl p-4 max-w-[718px] grid gap-y-4">
        <div class="grid gap-y-2">
            <p class="text-xl font-bold text-primary">{{campaign.title}}</p>
            <img :src="campaign.imageUrl">
            <!-- {{campaign.imageUrl}} -->
        </div>
        <div class="grid gap-y-2">
            <p class="text-base font-bold text-primary">Descrição</p>
            <div class="text-base" v-html="campaign.description"></div>
        </div>
        <div v-if="campaign.startDate && campaign.endDate">
            <p class="text-base font-bold text-primary">Período de Campanha</p>
            De {{formatDate(campaign.startDate)}} até {{formatDate(campaign.endDate)}}
        </div>
        <!-- <div class="grid gap-y-2">
            <p class="text-base font-bold text-primary">Data</p>
            <p class="text-base">{{formatUpdatedDate(campaign.createdAt)}}</p>
        </div> -->
        <div class="grid gap-y-2" v-if="campaign.items.length > 0">
            <p class="text-base font-bold text-primary">Baixar</p>
            <div class="flex gap-x-2">
                <!-- {{campaign.items}} -->
                <Icon v-for="(item, key) in campaign.items.filter(el => el.deletedAt == undefined)" :key="key" @click="downloadItems(item.mediaUrl)" class="cursor-pointer" name="Baixar"/>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from '@/Components/UI/Icons/Icon.vue';
import download from 'downloadjs';
import moment from 'moment'

export default {
    components: {
        Icon
    },
    props: {
        campaign: Object
    },
    methods: {
        downloadItems(imageUrl) {

            axios
            .get(this.route('download'), {
                headers: this.headers,
                responseType: 'blob', // had to add this one here
                params: {
                    imageUrl: imageUrl,
                },
            })
            .then(response => {
                // console.log(response)
                const content = response.headers['content-type'];
                download(response.data, response.headers['content-disposition'].split('filename=')[1].split(';')[0], content)
            })
            .catch(error => console.log(error));
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        }
    }
}
</script>
